// extracted by mini-css-extract-plugin
export var layout = "style-module--layout--10877";
export var opacity = "style-module--opacity--662b5";